<template>
    <div class="tripsHistoryTableColumnSelection">
        <icon-button icon="fa-eye" @click="openModal">
            Column visibility
        </icon-button>

        <confirm-modal ref="modal" :show-cancel="false" :show-confirm="false">
            <span slot="title"> <i class="fa fa-columns"></i> Column Visibility </span>

            <div slot="body">
                <checkbox-grid
                    :items="columnItems"
                    columns="3"
                    selection-buttons
                    small-buttons
                    @toggle="onSelectionChanged"
                    @toggle-all="onSelectionChanged"
                >
                </checkbox-grid>
            </div>
        </confirm-modal>
    </div>
</template>

<script>
import Vue from 'vue';

import CheckboxGrid from '../checkboxGrid/CheckboxGrid';
import ConfirmModal from '../ConfirmModal';
import IconButton from '../iconButton/IconButton';

export default {
    name: 'TableColumnSelection',

    props: {
        tableHeaders: {
            type: Array,
            required: true
        }
    },
    components: {
        CheckboxGrid,
        ConfirmModal,
        IconButton
    },

    data() {
        return {
            columnItems: []
        };
    },

    methods: {
        openModal() {
            Vue.set(this, 'columnItems', this.tableHeaders); // need this to make the new array reactive :(

            this.$refs.modal.$emit('open');
        },

        onSelectionChanged() {
            this.$emit('selection-changed', this.columnItems);
        }
    }
};
</script>
